"use client"

import { useSnapshot } from "valtio"
import { AccountState } from "../../stores/accountStore"

export function useAddress() {
  const { address } = useSnapshot(AccountState)
  return address
}
